<template>
  <div class="logsig">
    <div class="w12">
      <div class="hyjr">
        欢迎加入律观网 <span>(只需3小步骤即可轻松注册)</span>
      </div>
      <div class="steps between mt30">
        <div class="step center" :class="{ tepact: 1 <= currentactep }">
          <div class="xh">{{ 1 }}</div>
          <div>选择会员类型</div>
        </div>

        <div class="step center" :class="{ tepact: 2 <= currentactep }">
          <div class="xh">{{ 2 }}</div>
          <div>填写注册信息</div>
        </div>

        <div class="step center" :class="{ tepact: 3 <= currentactep }">
          <div class="xh">{{ 3 }}</div>
          <div>注册成功</div>
        </div>
      </div>
      <router-view class="mt50" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentactep: null,
    };
  },
  created(){
      this.$store.commit('user/modifylt','欢迎注册')
  },
};
</script>

<style lang="scss" scoped>
.logsig {
  background: #f4f8ff;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
  }
  .hyjr {
    font-size: 24px;
    color: #333333;
    span {
      font-size: 16px;
      color: #bbbbbb;
    }
  }
  .steps {
    .step {
      width: 300px;
      font-size: 16px;
      color: #bbbbbb;
      position: relative;
      .xh {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #bbbbbb;
        border-radius: 50%;
        font-size: 18px;
        color: #ffffff;
        margin-right: 10px;
      }
      &::after {
        content: "";
        position: absolute;
        left: -220px;
        width: 290px;
        height: 1px;
        background: #e2e2e2;
      }
      &:first-child {
        &::after {
          width: 70px;
          left: 0px;
        }
      }
      &:last-child {
        &::before {
          content: "";
          position: absolute;
          right: 0;
          width: 80px;
          height: 1px;
          background: #e2e2e2;
        }
      }
      &.tepact {
        color: #333333;
        .xh,
        &::after,
        &::before {
          background: #0057ff;
        }
      }
    }
  }
}
</style>